import { render, staticRenderFns } from "./CategorySection.vue?vue&type=template&id=0fb0eb7b"
import script from "./CategorySection.vue?vue&type=script&lang=js"
export * from "./CategorySection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports